export default {
  api: {
    error: {
      400: 'Erreur de validation par le serveur',
      502: 'Erreur de communication du serveur',
      500: 'Erreur interne du serveur',
    },
  },
  rgpd: {
    dateCreation: {
      F: 'Créée le : ',
      M: 'Créé le : ',
    },
    chargeCreation: 'par : ',
    demandeurCreation: 'Demande de : ',
    dateModification: {
      F: 'Modifiée le : ',
      M: 'Modifié le : ',
    },
    chargeModification: 'par : ',
  },
  entetes: {
    telephone: 'Téléphone (0)| Téléphone (1)| Téléphones ({count})',
    adresse:
      'Adresse postale (0)| Adresse postale (1)| Adresses postales ({count})',
    participant: 'Participant (0)| Participant (1)| Participants ({count})',
    gestionnaire: 'Gestionnaire| Gestionnaire| Gestionnaires',
  },
};
